"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NormativeSentenceDetector = void 0;
const sentence_splitter_1 = require("./sentence-splitter");
class NormativeSentenceDetector {
    static { this.PHRASES = [
        'must(?: not)?',
        'should(?: not)?',
        'shall',
        'recommend(?:s|ed|ation)?',
        'requir(?:e[sd]?|ing)',
        'do not',
        'never',
        'ensure[sd]?',
        'connect(?:s|ed)?',
        'tied?',
        'place[sd]?',
        'use[d]?(?! of\\b)',
        'keeps?',
        'selects?',
        'avoids?',
    ]; }
    static { this.TEST_PATTERN = NormativeSentenceDetector.phrasePattern('i'); }
    static matches(sentence) {
        return NormativeSentenceDetector.TEST_PATTERN.test(sentence);
    }
    static detect(text) {
        return sentence_splitter_1.SentenceSplitter.split(text).filter((sentence) => NormativeSentenceDetector.matches(sentence));
    }
    static highlightPattern() {
        return NormativeSentenceDetector.phrasePattern('gi');
    }
    static phrasePattern(flags) {
        return new RegExp(`\\b(?:${NormativeSentenceDetector.PHRASES.join('|')})\\b`, flags);
    }
}
exports.NormativeSentenceDetector = NormativeSentenceDetector;
//# sourceMappingURL=normative-sentence-detector.js.map